import React, { type ReactNode } from "react";
import { BaseInputV2AdornmentContext } from "src/components/BaseInputV2/BaseInputV2AdornmentContext.tsx";

export const EndAdornment = ({
  endAdornment,
  disabled = false,
}: {
  endAdornment: ReactNode;
  disabled?: boolean;
}) => {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <BaseInputV2AdornmentContext.Provider
        value={{
          disabled,
          position: "end",
        }}
      >
        {endAdornment}
      </BaseInputV2AdornmentContext.Provider>
    </div>
  );
};
